"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _OpenOrdersComponent = _interopRequireDefault(require("./OpenOrdersComponent"));
var _orderHistorySelectors = require("../../../redux/selectors/orderHistorySelectors");
var _instrumentPositionSelectors = require("../../../redux/selectors/instrumentPositionSelectors");
var _orderHistoryActions = require("../../../redux/actions/orderHistoryActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var makeMapStateToProps = function makeMapStateToProps() {
  var openOrdersSelector = (0, _orderHistorySelectors.openOrdersSelectorFactory)();
  return function (state, _ref) {
    var config = _ref.config,
      selectedInstrument = _ref.selectedInstrument;
    var _state$apexCore$order = state.apexCore.orderHistory,
      activeRequests = _state$apexCore$order.activeRequests,
      openOrdersStartIndex = _state$apexCore$order.openOrdersStartIndex;
    var openOrders = openOrdersSelector(state, config);
    var instruments = (0, _instrumentPositionSelectors.instrumentSelectorInstruments)(state);
    var fetching = activeRequests > 0;
    return {
      data: openOrders,
      instruments: instruments,
      fetching: fetching,
      selectedInstrument: selectedInstrument,
      openOrdersStartIndex: openOrdersStartIndex,
      selectedAccountId: state.user.selectedAccountId,
      OMSId: state.user.userInfo.OMSId
    };
  };
};
var mapDispatchToProps = {
  getOpenOrders: _orderHistoryActions.getOpenOrders,
  cancelOrders: _orderHistoryActions.cancelOrders,
  resetActivePage: _orderHistoryActions.resetActivePage
};
var _default = exports["default"] = (0, _reactRedux.connect)(makeMapStateToProps, mapDispatchToProps)(_OpenOrdersComponent["default"]);